<template>
  <div
    class="main-wrapper"
    v-resize-observer="{
      openResize: true,
      handler: observerCallBack
    }"
  >
    <div>
      <div class="top">
        <Banner />
        <Reminder :containerWidth="mainWrapperWidth" v-if="isShowReminder" />
      </div>
      <div>
        <el-tabs v-model="activeTab" class="dashboard-tabs" :class="{ 'single-tab': false, ar: ['ar', 'fa'].includes(lang) }">
          <el-tab-pane :label="$t('propTrade.dashboard.accounts')" name="accounts">
            <AccountsTabContent :mainWrapperWidth="mainWrapperWidth" />
          </el-tab-pane>
          <el-tab-pane :label="$t('propTrade.dashboard.paymentStatus')" name="paymentStatus">
            <PaymentStatusTabContent :mainWrapperWidth="mainWrapperWidth" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import AccountsTabContent from '@/components/propTrading/components/dashboard/AccountsTabContent.vue';
import PaymentStatusTabContent from '@/components/propTrading/components/dashboard/PaymentStatusTabContent.vue';
import Reminder from '@/components/propTrading/components/Reminder.vue';
import Banner from '@/components/propTrading/components/Banner.vue';
import auditStatus from '@/constants/auditStatus';
import splitThousands from '@/util/splitThousands';
import { mapState } from 'vuex';

export default {
  name: 'PropTradingDashBoard',
  components: { AccountsTabContent, PaymentStatusTabContent, Reminder, Banner },
  data() {
    return {
      mainWrapperWidth: 0,
      activeTab: 'accounts',
      mobileShowDetail: false
    };
  },
  computed: {
    ...mapState('common', ['poiAuditStatus', 'poaAuditStatus']),
    lang() {
      console.log('lang', this.$store.state.common.lang)
      return this.$store.state.common.lang;
    },
    isShowReminder() {
      return this.poiAuditStatus !== auditStatus.completed || this.poaAuditStatus !== auditStatus.completed;
    }
  },
  mounted() {
    this.init();
    let { account, session } = this.$store.state.propTrading;

    if (account) {
      this.activeTab = 'accounts';
    } else {
      this.activeTab = 'paymentStatus';
    }
  },
  methods: {
    async init() {},
    observerCallBack(width) {
      this.mainWrapperWidth = width;
    },
    formateAmount(amount) {
      return splitThousands(amount, 2);
    }
  }
};
</script>
<style lang="scss" scoped>
.top {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}

/deep/ .dashboard-tabs {
  &.ar {
    .el-tabs__content {
      direction: rtl;
    }
  }
}
/deep/ .el-tabs__nav-scroll {
  direction: ltr;
}
</style>
